import i18next from "i18next";
import { isEnglishActive } from "@/lib/lang-mode";

/**
 * Visar kategorinamnet på användarens språk. Det svenska namnet är alltid
 * det interna värdet (statistik, urval) – bara etiketten översätts.
 */
export function categoryLabel(category: string): string {
  return i18next.t(`categories.${category}`, {
    defaultValue: category,
    ns: "common",
    ...(isEnglishActive() ? { lng: "en" } : {}),
  });
}
